import React from 'react';
import { createPortal } from 'react-dom';
import { ButtonSimple } from '../../newStudent/Buttons';
import { HiTrash } from 'react-icons/hi';
import * as S from './styles';

interface IDeleteConfirmModalProps {
  isOpen: boolean;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function DeleteConfirmModal({
  isOpen,
  message,
  onConfirm,
  onCancel,
}: IDeleteConfirmModalProps) {
  if (!isOpen) return null;

  const modalContent = (
    <S.ModalWrapper onClick={onCancel}>
      <S.ModalContent onClick={(e) => e.stopPropagation()}>
        <S.IconWrapper>
          <HiTrash size={32} />
        </S.IconWrapper>
        <S.Message>{message}</S.Message>
        <S.Actions>
          <ButtonSimple color="danger" onClick={onConfirm}>
            Confirmar
          </ButtonSimple>
          <ButtonSimple color="primary" onClick={onCancel}>
            Cancelar
          </ButtonSimple>
        </S.Actions>
      </S.ModalContent>
    </S.ModalWrapper>
  );

  return createPortal(modalContent, document.body);
}

